import PropTypes from 'prop-types'
import React from 'react'
import STSComponent from '../../STSComponent/STSComponent'
import TabContent from '../../Tab/TabContent'
import TabLabel from '../../Tab/TabLabel'

class TabsWrapper extends STSComponent {
  constructor (props) {
    super(props)
    this.state = {
      activeTab: 'legis'
    }
    this.changeTab = this.changeTab.bind(this)
  }

  changeTab = (tabName) => () => {
    this.setState({ activeTab: tabName })
  }

  render () {
    const { activeTab } = this.state
    const { legis, regs, local } = this.props
    return <React.Fragment>
      <div className="tab-label">
        <TabLabel onClick={this.changeTab} tabName="legis"
          isActive={activeTab === 'legis'}>Legislative Tracking
        </TabLabel>
        <TabLabel onClick={this.changeTab} tabName="regs"
          isActive={activeTab === 'regs'}>Regulatory Tracking
        </TabLabel>
        <TabLabel onClick={this.changeTab} tabName="local"
          isActive={activeTab === 'local'}>Local Tracking
        </TabLabel>
      </div>
      <TabContent isActive={activeTab === 'legis'}>{legis}</TabContent>
      <TabContent isActive={activeTab === 'regs'}>{regs}</TabContent>
      <TabContent isActive={activeTab === 'local'}>{local}</TabContent>
    </React.Fragment>
  }

  static propTypes = {
    legis: PropTypes.node,
    regs: PropTypes.node,
    local: PropTypes.node
  }
}

export default TabsWrapper



// WEBPACK FOOTER //
// ./src/components/ManagementTools/components/TabsWrapper.js